import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryTabs() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentSlug = location.pathname.split('/category/')[1] || '';

  const handleClick = useCallback(
    (slug: string) => {
      navigate(`/category/${slug}`);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    [navigate],
  );

  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide">
      <button
        type="button"
        onClick={() => handleClick(categories[0].slug)}
        className={`px-4 py-2 text-sm font-medium rounded-full whitespace-nowrap cursor-pointer transition-colors ${
          currentSlug === categories[0].slug || !currentSlug
            ? 'bg-primary-500 text-white'
            : 'bg-background-100 text-foreground-600 hover:bg-background-200'
        }`}
      >
        全部
      </button>
      {categories.map((cat) => (
        <button
          key={cat.id}
          type="button"
          onClick={() => handleClick(cat.slug)}
          className={`flex items-center gap-1.5 px-4 py-2 text-sm font-medium rounded-full whitespace-nowrap cursor-pointer transition-colors ${
            currentSlug === cat.slug
              ? 'bg-primary-500 text-white'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200'
          }`}
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className={cat.icon} style={{ width: '14px', height: '14px' }}></i>
          </div>
          {cat.name}
        </button>
      ))}
    </div>
  );
}